export interface RedirectPath {
    pathname: string;
    storageTimestamp: string;
}

export enum StorageKey {
    REDIRECT_PATH = 'REDIRECT_PATH',
    ACTIVITY_TIMESTAMP = 'ACTIVITY_TIMESTAMP',
    SELECTED_MEMBERSHIP_ID = 'SELECTED_MEMBERSHIP_ID',
    SELECTED_MEMBERSHIP = 'SELECTED_MEMBERSHIP',
    SELECTED_WORKFLOW_RUN = 'SELECTED_WORKFLOW_RUN',
    MEMBERSHIP_MESSAGING_VIEW_MODE = 'MEMBERSHIP_MESSAGING_VIEW_MODE',
    ALL_MESSAGE_DRAFTS = 'ALL_MESSAGE_DRAFTS',
    ALL_EXPANDED_GOALS = 'ALL_EXPANDED_GOALS',
    SIDEBAR_FRUIT_SLICE_ID = 'SIDEBAR_FRUIT_SLICE_ID',
    SIDEBAR_RAIL_WIDTH = 'SIDEBAR_RAIL_WIDTH',
}
